import { Flex } from '@repo/ui/Flex';
import s from './EmptyMessage.module.css';
import { type LanguageCore, Text } from '../Language/Language';

export const EmptyMessage = ({ language }: { language: LanguageCore }) => (
  <Flex
    alignItems="center"
    justifyContent="center"
    padding="p-48"
    className={s.wrapper}
  >
    <div>
      <Text {...language} />
    </div>
  </Flex>
);
